export default {
  resources: {
    badge: 'Ressources et centre de connaissance',
    title: 'Toutes les ressources',
    subtitle: 'Cas clients, guides pratiques et tendances sectorielles pour optimiser la livraison et les opérations flotte.',
    successStories: 'Cas clients',
    successStoriesSub: 'Des résultats concrets d\'équipes de livraison réelles',
    learning: 'Formation',
    learningSub: 'Articles, whitepapers et guides',
    stats: {
      caseStudies: 'Études de cas',
      blogArticles: 'Articles de blog',
      whitepapers: 'Whitepapers',
    },
    ctaTitle: 'Prêt à voir Geofleet en action ?',
    ctaSubtitle: 'Commencez dès maintenant ou réservez une démo pour des résultats similaires dans vos opérations.',
    ctaTrial: 'Commencer',
    ctaDemo: 'Réserver une démo',
    explore: 'Explorer',
    howItWorks: {
      title: 'Comment ça marche',
      subtitle: 'Simple à parcourir, rapide pour trouver ce dont vous avez besoin',
    },
    whatsInside: {
      badge: 'Ce que vous trouverez',
      title: 'Tout ce que {{name}} propose',
    },
    whyItMatters: {
      title: 'Pourquoi c\'est important',
      subtitle: 'Faits clés sur {{name}}',
    },
    cta: {
      exploreTitle: 'Prêt à explorer {{name}} ?',
      exploreSubtitle: 'Commencez en quelques minutes. Plans dès 100 $ par mois pour 10 chauffeurs.',
    },
  },
};
